function Search_algolia_autocomplete(element) {
  this.loaded = false;
  this.algoliaSearchSrc = element.dataset.algoliaSearchSrc;
  this.algoliaAutocompleteSrc = element.dataset.algoliaAutocompleteSrc;

  /**
   * init decorator
   */
  this.init = function() {
    // console.log("Search_algolia_autocomplete init...");

    if (!this.loaded) {
      this.loadAlgoliaLibraries();
    }

    this.loaded = true;
  };


  /**
   * inject remote CDN scripts used for algolia autocomplete search client
   */
  this.loadAlgoliaLibraries = function () {
    const algoliasearch = document.createElement('script');
    algoliasearch.type = 'text/javascript';
    algoliasearch.async = false;
    algoliasearch.src = this.algoliaSearchSrc;

    let s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(algoliasearch, s);

    const autocomplete = document.createElement('script');
    autocomplete.type = 'text/javascript';
    autocomplete.async = false;
    autocomplete.src = this.algoliaAutocompleteSrc;

    s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(autocomplete, s);
  };
}

